// extracted by mini-css-extract-plugin
export default {"labelText":"yTGTY___labels-module__labelText"};